import React from 'react';
import { Rate } from 'antd';

interface StudentProjectReviewProps {
  userProject: UserProject;
}

export const StudentProjectReview: React.FC<StudentProjectReviewProps> = ({ userProject }) => {
  if (!userProject?.grades || userProject?.grades.length === 0) return null;

  return (
    <div style={{ marginTop: 8 }}>
      <h3>Project review</h3>
      {userProject.grades.map((grade) => (
        <>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
            <div style={{ display: 'flex', flex: 1 }}>
              <p style={{ margin: 0, lineHeight: '32px' }}>{grade.goal?.text}</p>
            </div>
            <div style={{ display: 'flex' }}>
              <Rate value={grade.grade} disabled={true} style={{ fontSize: '16px' }} />
            </div>
          </div>
          <div>
            <p style={{ margin: '8px 0' }}>
              <b>Instructor's note</b>: <br /> {grade.note ? grade.note : 'No note.'}
            </p>
          </div>
          <hr />
        </>
      ))}
      <h4>General note</h4>
      {userProject.note ? <p>{userProject.note}</p> : null}
    </div>
  );
};
